'use strict'
import api from '@/api/api'
import notify from "@/utils/notify"

export default {
  async getAllSales(params = {}) {
    // params: { page, per_page, search }
    const query = new URLSearchParams()
    if (params.page) query.set('page', params.page)
    if (params.per_page) query.set('per_page', params.per_page)
    if (params.search) query.set('search', params.search)

    const data = {
      method: 'get',
      url: `sales${query.toString() ? `?${query.toString()}` : ''}`,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },
  async getStoreSales(id, params = {}) {
    const query = new URLSearchParams()
    if (params.page) query.set('page', params.page)
    if (params.per_page) query.set('per_page', params.per_page)
    if (params.search) query.set('search', params.search)

    const data = {
      method: 'get',
      url: `sales/${id}${query.toString() ? `?${query.toString()}` : ''}`,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },
  async getSale(id) {
    const data = {
      method: 'get',
      url: 'sale/' + id,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },
  async createSale(json) {
    const data = {
      method: 'post',
      url: 'sale',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 201) {
      notify.alert.success('Sale added successfully', 2000)
      return true;
    }
  },
  async createReturn(json) {
    const data = {
      method: 'post',
      url: 'sale-return',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 201) {
      notify.alert.success('Sale return processed successfully', 2000)
      return true;
    }
  },
  async getSaleDetails(id) {
    const data = {
      method: 'get',
      url: 'sale/' + id + '/details',
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },
  async getSaleReference() {
    const data = {
      method: 'get',
      url: 'saleReference',
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },
  async stkRequest(json) {
    const data = {
      method: 'post',
      url: '/stkRequest',
      body: json,
    }

    return await api.api(data)
  },
  async getCompleteStk(json) {
    const data = {
      method: 'post',
      url: '/completeStk',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    } else {
      return false
    }
  },
  async getReturns(id, params = {}) {
    const query = new URLSearchParams()
    if (params.page) query.set('page', params.page)
    if (params.per_page) query.set('per_page', params.per_page)
    if (params.search) query.set('search', params.search)

    const data = {
      method: 'get',
      url: `sale-returns/${id}${query.toString() ? `?${query.toString()}` : ''}`,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
    return []
  },
  async getReturnDetails(id) {
    const data = {
      method: 'get',
      url: 'sale-return/' + id,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },
  async initiatePDQ(json) {
    const data = {
      method: 'post',
      url: '/initiatePDQ',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200 || response.status === 201) {
      return response.data
    }
    return false
  },
  async resultsPDQ(json) {
    const data = {
      method: 'post',
      url: '/resultsPDQ',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200 || response.status === 201) {
      return response.data
    }
    return false
  },
}

